/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { type ContactEntity, contactSchema } from '@axiom/domain';
import { eSUserDAOSchema } from './es-user-dao';

export const eSAccountContactDAOSchema = contactSchema.pick({ "firstName": true, "id": true, "lastName": true }).extend({ "user": z.lazy(() => eSUserDAOSchema).nullish() });
export type ESAccountContactDAO = Pick<ContactEntity, "firstName" | "id" | "lastName"> & z.infer<typeof eSAccountContactDAOSchema>;
